import {
  type CreateRoleRequest,
  type PermissionRegistryResponse,
  PermissionRegistryResponseSchema,
  type RoleDetail,
  RoleDetailSchema,
  type RoleListQuery,
  type RoleListResponse,
  RoleListResponseSchema,
  type SetRolePermissionsRequest,
  type UpdateRoleRequest,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

/**
 * Roles API (ADR-0039). Phase 1: list + detail + registry. Phase 2 adds
 * create / update / soft-delete / set-permissions, all audited
 * server-side.
 */

export const listRoles = async (query: RoleListQuery): Promise<RoleListResponse> => {
  const { data } = await apiClient.get<unknown>('/roles', { params: query });
  return RoleListResponseSchema.parse(data);
};

export const getRole = async (id: string): Promise<RoleDetail> => {
  const { data } = await apiClient.get<unknown>(`/roles/${id}`);
  return RoleDetailSchema.parse(data);
};

export const getPermissionRegistry = async (): Promise<PermissionRegistryResponse> => {
  const { data } = await apiClient.get<unknown>('/roles/registry');
  return PermissionRegistryResponseSchema.parse(data);
};

export const createRole = async (payload: CreateRoleRequest): Promise<RoleDetail> => {
  const { data } = await apiClient.post<unknown>('/roles', payload);
  return RoleDetailSchema.parse(data);
};

export const updateRole = async (id: string, payload: UpdateRoleRequest): Promise<RoleDetail> => {
  const { data } = await apiClient.patch<unknown>(`/roles/${id}`, payload);
  return RoleDetailSchema.parse(data);
};

export const deleteRole = async (id: string): Promise<void> => {
  await apiClient.delete(`/roles/${id}`);
};

export const setRolePermissions = async (
  id: string,
  payload: SetRolePermissionsRequest,
): Promise<RoleDetail> => {
  const { data } = await apiClient.put<unknown>(`/roles/${id}/permissions`, payload);
  return RoleDetailSchema.parse(data);
};
